import * as React from "react";
import { Text, makeStyles } from "@fluentui/react-components";

const useStyles = makeStyles({
  relationItem: {
    display: "grid",
    gap: "6px",
  },
  relationHeader: {
    display: "flex",
    gap: "8px",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
  },
  relationActions: {
    display: "flex",
    gap: "6px",
    alignItems: "center",
  },
});

export interface RelationRowControlProps {
  label: string;
  actions?: React.ReactNode;
  children: React.ReactNode;
}

export function RelationRowControl({ label, actions, children }: RelationRowControlProps): JSX.Element {
  const styles = useStyles();

  return (
    <div className={styles.relationItem}>
      <div className={styles.relationHeader}>
        <Text weight="semibold">{label}</Text>
        {actions ? <div className={styles.relationActions}>{actions}</div> : null}
      </div>

      {children}
    </div>
  );
}